import {getLoginUrl} from "@project/application";
import {HelitecnicaLogo} from "@project/components/branding/helitecnica-logo";
import {Button, Card} from "@project/design-system-web";
import {createFileRoute} from "@tanstack/react-router";

export interface LoginSearch {
  redirect?: string;
}

export const Route = createFileRoute("/login")({
  component: LoginPage,
  validateSearch: (search): LoginSearch => ({
    redirect: typeof search.redirect === "string" ? search.redirect : undefined,
  }),
});

function LoginPage() {
  const {redirect} = Route.useSearch();

  function handleLogin() {
    window.location.assign(getLoginUrl(redirect ?? "/"));
  }

  return (
    <main className="flex min-h-dvh items-center justify-center p-6">
      <Card className="w-full max-w-sm gap-4">
        <Card.Header className="items-center gap-3">
          <HelitecnicaLogo className="block h-16 w-56" />
          <Card.Title>Welcome back</Card.Title>
          <Card.Description>Sign in with your organization credentials.</Card.Description>
        </Card.Header>
        <Card.Footer>
          <Button className="w-full" onPress={handleLogin}>
            Continue
          </Button>
        </Card.Footer>
      </Card>
    </main>
  );
}
